import React from "react";
import PageLayout from "../components/PageLayout";

export default function Loja() {
  const cards = [
    {
      title: "Material académico",
      text: "Produtos essenciais para acompanhar aulas, organizar estudos e preparar trabalhos.",
      points: ["Cadernos", "Pastas", "Acessórios"],
    },
    {
      title: "Impressão e acabamento",
      text: "Documentos produzidos conforme formato, quantidade e apresentação necessária.",
      points: ["Cópias", "Encadernação", "Plastificação"],
    },
    {
      title: "Brindes personalizados",
      text: "Peças para equipas, clientes, eventos e campanhas com aplicação da sua marca.",
      points: ["Selecção do produto", "Personalização", "Produção"],
    },
  ];
  return (
    <PageLayout
      eyebrow="Loja CENFOTEP"
      title="Produtos e serviços para estudar, trabalhar e comunicar."
      intro="Encontre materiais, impressão e personalização com atendimento capaz de orientar especificações, quantidades e prazos."
      sectionTitle="O que encontra na nossa loja"
      sectionIntro="Consulte disponibilidade e valores. Pedidos personalizados são analisados antes da confirmação da produção."
      cards={cards}
    />
  );
}
